import React from "react";
import { Link } from "react-router-dom";

function RightTag() {
  return (
    <div>
      <ul className="right-tag">
        <Link to="/sobre-nosotros">
          <li>Sobre este proyecto</li>
        </Link>
      </ul>
    </div>
  );
}

export default RightTag;
